import s from './Vouchers.module.scss';
import { ReactComponent as RiyalIcon } from 'images/new-icons/riyal.svg';
import clsx from 'clsx';

interface VoucherCardProps {
  variant?: 'pink' | 'teal' | 'yellow' | 'purple' | 'blue' | 'green' | 'orange' | 'red';
  value: number;
  validUntil: string;
  validFor: string;
  salonName: string;
  serviceName?: string;
  avatarSrc?: string;
  style?: React.CSSProperties;
}

export const VoucherCard = ({
  variant = 'pink',
  value,
  validUntil,
  salonName,
  serviceName,
  style
}: VoucherCardProps) => {
  return (
    <div style={style} className={clsx(s.gift_card, s[`gift_card_${variant}`])}>
      <div className={s.gift_main}>
        <div className={s.gift_valid}>
          Valid Until {validUntil}
          <br />
          Valid for {serviceName}
        </div>

        <h1 className={s.gift_title}>
          GIFT<br />VOUCHER
        </h1>

        <div className={s.gift_brand}>{salonName}</div>
        <div className={s.gift_site}>Beautify.sa</div>
      </div>

      <div className={s.gift_stub}>
        <div className={s.gift_amount}>
          <div className={s.gift_amount_value_wrapper}>
            <div 
              className={s.gift_amount_value}
              style={{ 
                fontSize: value.toString().length >= 5
                  ? 'clamp(16px, 7vw, 26px)' 
                  : value.toString().length === 4
                    ? 'clamp(18px, 8vw, 32px)' 
                    : value.toString().length === 3 
                      ? 'clamp(22px, 10vw, 40px)' 
                      : undefined
              }}
            >
              {value}
            </div>
          </div>
          
          <RiyalIcon 
            className={s.riyal_icon_small} 
            style={{ 
              width: value.toString().length >= 4 ? '16px' : value.toString().length === 3 ? '18px' : '24px',
              height: value.toString().length >= 4 ? '16px' : value.toString().length === 3 ? '18px' : '24px',
              flexShrink: 0
            }}
          />
        </div>
      </div>
    </div>
  );
};
